import React from "react";

type ContextProps = {
  isDrawerOpen: boolean;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Context = React.createContext<ContextProps | undefined>(undefined);

type ProviderProps = {
  children: React.ReactNode;
};

export const NavDrawerProvider = (props: ProviderProps) => {
  const { children } = props;
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const value = {
    isDrawerOpen,
    setIsDrawerOpen,
  };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useNavDrawer = (): ContextProps => {
  const context = React.useContext(Context);

  if (context === undefined) {
    throw new Error("useNavDrawer must be used within a NavDrawerProvider");
  }

  return context;
};
